/**
 * AbortControllerManager
 *
 * Manages AbortControllers for API requests to prevent race conditions.
 * Automatically aborts previous requests when new ones are made.
 */
export class AbortControllerManager {
  private controllers: Record<string, AbortController | null> = {};

  constructor(requestTypes: string[] = []) {
    requestTypes.forEach(type => {
      this.controllers[type] = null;
    });
  }

  /**
   * Get an AbortController for a request type.
   * Aborts any existing request of the same type.
   */
  getController(requestType: string): AbortController {
    if (this.controllers[requestType]) {
      this.controllers[requestType]?.abort();
    }
    const controller = new AbortController();
    this.controllers[requestType] = controller;
    return controller;
  }

  /**
   * Clear the controller reference after request completes.
   * Call this in .finally() blocks.
   */
  clear(requestType: string): void {
    this.controllers[requestType] = null;
  }

  /**
   * Abort a specific request type and clear its reference.
   */
  abort(requestType: string): void {
    this.controllers[requestType]?.abort();
    this.controllers[requestType] = null;
  }
}

export default AbortControllerManager;
